<template>
  <UIButton
    :label="label"
    :link="link"
    :disabled="continueDisabled"
    @click="done"
  />
</template>

<script setup lang="ts">
  import UIButton from "@ui-kit/components/button"
  import {
    type FlowOutcome,
    ScreenId,
  } from "@versatile-credit-apply/omni-apply-client"
  import { useI18n } from "vue-i18n"
  import { computed, toRef } from "vue"
  import { useExitFlow } from "@/composition"

  const { t } = useI18n()

  interface Props {
    outcome: FlowOutcome
    // Override the label (defaults to actions.done).
    labelOverride?: string
    // Add a link style to the button.
    link?: boolean
    screenId?: ScreenId
    continueDisabled?: boolean
  }

  const props = defineProps<Props>()

  const label = computed(() => props.labelOverride ?? t("actions.done"))
  const link = toRef(props, "link")

  const exitFlow = useExitFlow()
  const done = () => exitFlow(props.outcome, props.screenId)
</script>
